import { CommonSuccessResponse } from "constants/types/common";
import { Profile } from "constants/types/profile";
import useSWR from "swr";

export const PROFILE_KEY = "/profile";

export const useProfile = () => {
  const {
    data,
    error,
    isLoading,
    mutate,
  }: {
    data: CommonSuccessResponse<Profile> | undefined;
    error: any;
    isLoading: boolean;
    mutate: any;
  } = useSWR(PROFILE_KEY, {
    refreshInterval: 0,
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
  });

  return {
    profile: data?.data,
    error,
    isLoading,
    mutate,
  };
};
